export default {
  'levels.name': 'Hạng thành viên',
  'levels.title': 'Nhập',
  'levels.heading': 'Danh sách hạng thành viên',
  'levels.code': 'Tên hạng',
  'levels.discount': 'Tỉ lệ chiết khấu (%)',
  'levels.minimumRevenue': 'Số tiền tối thiểu',
};
